import React from "react";
import { Route, Switch } from "react-router-dom";
import AccessoryCreation from "./Home";
import Accessory from "./Accessory";

function AccessoryCreationIndex() {
  return (
    <Switch>
      <Route
        exact={true}
        path={"/accessories"}
        render={(props) => {
          return <AccessoryCreation {...props} />;
        }}
      />
      <Route
        path={"/accessories/accessory/:id/:series/:version"}
        render={(props) => {
          return <Accessory {...props} />;
        }}
      />
    </Switch>
  );
}

export default AccessoryCreationIndex;
